module.exports = __webpack_public_path__ + "static/media/sistema-vinculo-condutores-plano-starter.19a572f9.png";